"use client"
import CardTitle from "@/components/common/card-title";

import { PostBasePageContent } from "@/components/common/posts/post-base-page-content";


export default function Page() {

    return (
        <div className={"flex flex-col gap-6 pb-6"}>
            <CardTitle title={"Activités de l'office"}
                backgroundImgSrc={"/images/actualites/flash-infos/baniere.jpg"} />

            {/* Flash Infos Content */}
           <PostBasePageContent />
        </div>
    );
}
